export enum FormState {
  LOADING = 'loading',
  DISPLAYING = 'displaying',
  INTERACTING = 'interacting',
  SUBMITTING = 'submitting',
  CANCELLING = 'cancelling',
}
